import { FC } from 'react';
import { ClickAwayListener, Grow, MenuItem, MenuList, Paper } from '@mui/material';
import { classes, StyledPopper } from './FloatingButtonOptions.styles';
import { FloatingButtonOptionsProps } from './types';

const FloatingButtonOptions: FC<FloatingButtonOptionsProps> = ({
  optionsMenu,
  openOptionsButtonRef,
  isOpenSubMenu,
  setIsOpenSubMenu,
  getIcon,
}) => {
  const handleClose = () => {
    setIsOpenSubMenu(false);
  };

  return (
    <StyledPopper
      open={isOpenSubMenu}
      anchorEl={openOptionsButtonRef.current}
      role={undefined}
      transition
      disablePortal
      placement="top-end">
      {({ TransitionProps }) => (
        <Grow {...TransitionProps}>
          <Paper className={classes.paper}>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList id="split-button-menu" className={classes.menuList}>
                {optionsMenu.map((option, index) => (
                  <MenuItem
                    key={option.key}
                    id={`floating-button-options-btn-${index}`}
                    onClick={() => option.onClick(option)}>
                    {getIcon(option)}
                    <span>{option.label}</span>
                  </MenuItem>
                ))}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </StyledPopper>
  );
};

export default FloatingButtonOptions;
